function CaptionRow({ icon, children }) {
  return (
    <div className="captionRow">
      {icon ? (
        <span className="captionRow__icon" aria-hidden="true">
          {icon}
        </span>
      ) : null}
      <p className="captionRow__text">{children}</p>
    </div>
  );
}

export default CaptionRow;
